export class ValidationServiceLabelEN {

    validation: {
        required: string;
        confirmEmailValidation: string;
        confirmPANValidation: string;
        confirmTINValidation: string;
        tinValidation: string;
        salaryValidation: string;
        confirmMobileValidation: string;
        nameValidation: string;
        midNameValidation: string;
        dateValidation: string;
        toDateValidation: string;
        aadharValidation: string;
        itrIncomeValidation: string;
        downpaymentMaxValidation: string;
        downpaymentMinValidation: string;
        tenDigitPhoneValidation: string;
        thirtyCharExceedNameValidation: string;
        sixtyCharExceedNameValidation: string;
        twentyCharExceedLastNameValidation: string;
        tweleveDigitAdharValidation: string;
        fortyCharExceedAddressValidation: string;
        fiftyCharExceedAreaValidation: string;
        twentyFiveCharExceedCityValidation: string;
        sixDigitPinCodeValidation: string;
        tenDigitPANValidation: string;
        fifteenDigitNumericWithTwoDecimalValidation: string;
        notInRangeFinProduct: string;
        maxCharExceedValidation: string;
        maxValueExceedValidation: string;
        minIncome26000: string;
        minIncome312000: string;
        minValueValidation: string;
        validPhoneValidation: string;
        validNameValidation: string;
        validNumericAdharValidation: string;
        validEmailValidation: string;
        validPANValidation: string;
        validDesignationValidation: string;
        validPincodeValidation: string;
        validAmountValidation: string;
        numericValidation: string;
        noSpecialCharValidation: string;
        validVariantValidation: string;
        patternMismatchValidation: string;
        tenDigitValidPhoneValidation: string;
        min6CharValidation: string;
        tewelveDigitAdharValidation: string;
        min2CharValidation: string;
        min4CharValidation: string;
        min10CharValidation: string;
        minCharValidation: string;
        
    }

   

    constructor() {

        this.validation = {
            required: "This field is required.",
            confirmEmailValidation: 'Primary and Secondary Email addresses cannot be the same',
            confirmPANValidation: 'Confirm PAN and PAN fields have different values.',
            confirmTINValidation: 'Confirm TIN Number and TIN number have different values.',
            tinValidation: 'Enter a valid TIN number',
            salaryValidation: 'Net salary should be less than or equal to gross salary',
            confirmMobileValidation: 'Primary and Secondary Mobile numbers cannot be the same',
            nameValidation: 'Names cannot be the same',
            midNameValidation: 'Names cannot be the same',
            dateValidation: 'To Date should be greater than From',
            toDateValidation: 'From Date should not be greater than To Date',
            aadharValidation: 'Aadhar cannot be the same',
            itrIncomeValidation: 'ITR Income should be less than or equal to Annual Income',
            downpaymentMaxValidation: 'Downpayment has exceeded the Max allowed Value',
            downpaymentMinValidation: 'Downpayment Value is less than minimum value',
            tenDigitPhoneValidation: 'Please enter 10 digit phone number.',
            thirtyCharExceedNameValidation: 'Name should not exceed 30 characters.',
            sixtyCharExceedNameValidation: 'Name should not exceed 60 characters.',
            twentyCharExceedLastNameValidation: 'Last name should not exceed 20 characters.',
            tweleveDigitAdharValidation: 'Please enter 12 digit Aadhar number',
            fortyCharExceedAddressValidation: 'Address should not exceed 40 characters.',
            fiftyCharExceedAreaValidation: 'Area should not exceed 50 characters.',
            twentyFiveCharExceedCityValidation: 'City should not exceed 25 characters.',
            sixDigitPinCodeValidation: 'Please enter 6 digit pincode.',
            tenDigitPANValidation: 'Please enter 10 digit PAN.',
            fifteenDigitNumericWithTwoDecimalValidation: 'Please enter 15 digit numeric with maximum of 2 decimal values',
            notInRangeFinProduct: 'Not in Range allowed by Financial Product/Special Program',
            maxCharExceedValidation: 'Field has exceeded maximum number of characters.',
            maxValueExceedValidation: 'Field has exceeded the maximum value.',
            minIncome26000: 'Min. Income Rs. 26,000',
            minIncome312000: 'Min. Income Rs. 3,12,000',
            minValueValidation: 'Field is less than minimum value',
            validPhoneValidation: 'Please enter valid phone number',
            validNameValidation: 'Please enter valid name',
            validNumericAdharValidation: 'Please enter valid numeric Aadhar',
            validEmailValidation: 'Please enter valid email ID',
            validPANValidation: 'lease enter valid PAN',
            validDesignationValidation: 'Please enter valid designation',
            validPincodeValidation: 'Please enter valid Pincode',
            validAmountValidation: 'Please enter valid amount',
            numericValidation: 'Please enter Numeric values',
            noSpecialCharValidation: 'No special characters allowed',
            validVariantValidation: 'Please enter vaild Variant',
            patternMismatchValidation: 'Pattern mismatch.',
            tenDigitValidPhoneValidation: 'Please enter a 10 digit phone number',
            min6CharValidation: 'Please enter minimum of 6 characters',
            tewelveDigitAdharValidation: 'Please enter 12 digit Aadhar number',
            min2CharValidation: 'Please enter minimum of 2 characters',
            min4CharValidation: 'Please enter minimum of 4 characters',
            min10CharValidation: 'Please enter minimum 10 characters',
            minCharValidation: 'Please enter minimum number of characters.',
        }

    }
}